import {SEARCH_HOTELS_QUERY} from "@app/component/form/input/autocomplete/service/SeacrhGraphQLQueries";
import SearchHotelResult from "@app/component/form/input/autocomplete/SearchHotelResult";
import {GraphQLExecutor} from "@app/model/_common/service/GraphQLExecutor";


class SearchService {
    public static searchHotels(term: string) {
        return GraphQLExecutor.execute<SearchHotelResult[]>(SEARCH_HOTELS_QUERY, {term})
    }
}

export default SearchService